import { render, staticRenderFns } from "./CustomConfirmDialog.vue?vue&type=template&id=5789d1fd"
import script from "./CustomConfirmDialog.vue?vue&type=script&lang=js"
export * from "./CustomConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomConfirmDialog.vue?vue&type=style&index=0&id=5789d1fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports